import { useEffect, useState } from 'react';
import axiosInstance from "../../helpers/Axios";
import '../../css/adminphotos.scss';

type Folder = {
  name: string;
  files: string[];
};

const AdminPhotos = () => {
  const [folders, setFolders] = useState<Folder[]>([]);

  const load = async () => {
    const res = await axiosInstance.get('/image');
    setFolders(res.data);
  };


  useEffect(() => {
    load();
  }, []);

  const upload = async (folder: string, file: File) => {
    const form = new FormData();
    form.append('file', file);


    await axiosInstance.post(`/image/${folder}`, form, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });

    load();
  };


  const remove = async (folder: string, file: string) => {
    await axiosInstance.delete(`/image/${folder}/${file}`);
    load();
  };

  return (
    <div>

      <div className="admin-photos">
        <h1 className="admin-title">Admin Photos</h1>

        {folders.map(folder => (
          <section key={folder.name} className="photo-section">
            <header className="section-header">
              <h2>{folder.name}</h2>

              <label className="upload-btn">
                ➕ Ajouter une image
                <input
                  type="file"
                  hidden
                  onChange={e =>
                    e.target.files &&
                    upload(folder.name, e.target.files[0])
                  }
                />
              </label>
            </header>

            <div className="photo-grid">
              {folder.files.map(file => (
                <div key={file} className="photo-card">
                  <img
                    src={`${import.meta.env.VITE_BACKEND_URL}/images/${folder.name}/${file}`}
                    alt={file}
                    loading="lazy"
                  />
                  <button
                    className="delete-btn"
                    onClick={() => remove(folder.name, file)}
                  >
                    ✖
                  </button>
                </div>
              ))}
            </div>
          </section>
        ))}
      </div>

{/* 
      <h1>Admin Photos</h1>

      {folders.map(folder => (
        <section key={folder.name}>
          <h2>{folder.name}</h2>

          <input
            type="file"
            onChange={e =>
              e.target.files &&
              upload(folder.name, e.target.files[0])
            }
          />

          <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
            {folder.files.map(file => (
              <div key={file}>
                {`/images/${folder.name}/${file}`}
                <button onClick={() => remove(folder.name, file)}>
                  Supprimer
                </button>
              </div>
            ))}
          </div>
        </section>
      ))} */}
    </div>
  );
};

export default AdminPhotos;